import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { MentionsInput, Mention } from "react-mentions";
import moment from "moment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SendIcon from "@mui/icons-material/Send";
import CustomButton from "../../../components/@extended/CustomButton";

const CommentTab = ({
  commentHist,
  comment,
  users,
  onCommentChange,
  onSaveComment,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "95%",
        minHeight: 0, // Important for flex children to shrink properly
      }}
    >
      <List
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          flexGrow: 1,
          overflow: "auto",
          minHeight: 0, // Important for overflow to work in flex containers
        }}
      >
        {commentHist && commentHist.length > 0 ? (
          commentHist.map((_commentObj, index) => (
            <ListItem
              key={`comment${index}`}
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              <ListItemText
                primary={
                  <Tooltip
                    title={
                      <div
                        dangerouslySetInnerHTML={{
                          __html: _commentObj.comment,
                        }}
                      />
                    }
                    placement="left-start"
                  >
                    <div
                      style={{
                        width: 250,
                        maxWidth: 280,
                        whiteSpace: "balance",
                        overflow: "auto",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: _commentObj.comment,
                      }}
                    />
                  </Tooltip>
                }
                secondary={
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>{_commentObj.createdBy}</Typography>
                    <Box sx={{ display: "flex", columnGap: 1 }}>
                      <Typography>
                        {moment(_commentObj.createdAt).format(
                          "MM/DD/YYYY hh:mm a"
                        )}
                      </Typography>
                      {_commentObj.latitude && _commentObj.longitude && (
                        <Tooltip
                          title={`${_commentObj.latitude},${_commentObj.longitude}`}
                        >
                          <LocationOnIcon color="primary" />
                        </Tooltip>
                      )}
                    </Box>
                  </Box>
                }
              />
            </ListItem>
          ))
        ) : (
          <Typography sx={{ color: "grey", paddingY: 2 }}>
            No comment exist
          </Typography>
        )}
      </List>
      <Box
        sx={{
          display: "flex",
          padding: 2,
          justifyContent: "end",
          alignItems: "center",
          borderTop: `1px solid ${theme.palette.divider}`,
          flexShrink: 0, // Prevent input box from shrinking
          gap: 1.5, // Ensures some space between input and the button
        }}
      >
        <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
          <MentionsInput
            style={{
              width: "100%",
              minHeight: 40,
              maxHeight: 100,
              input: {
                padding: 9,
                border: "1px solid silver",
                "&focused": {
                  border: `1px solid ${theme.palette.primary.main}`,
                },
              },
              suggestions: {
                list: {
                  backgroundColor: "white",
                  border: "1px solid rgba(0,0,0,0.15)",
                  fontSize: 14,
                },
                item: {
                  padding: "5px 15px",
                  borderBottom: "1px solid rgba(0,0,0,0.15)",
                  "&focused": {
                    backgroundColor: theme.palette.primary.lighter,
                  },
                },
              },
            }}
            value={comment}
            onChange={onCommentChange}
            forceSuggestionsAboveCursor
            allowSpaceInQuery
            allowSuggestionsAboveCursor
            placeholder={`Enter "@" to mention user`}
          >
            <Mention trigger="@" data={users} appendSpaceOnAdd />
          </MentionsInput>
        </Box>
        <CustomButton
          variant="contained"
          onClick={onSaveComment}
          sx={{
            minWidth: 40,
            minHeight: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ml: 1,
          }}
        >
          <SendIcon />
        </CustomButton>
      </Box>
    </Box>
  );
};

export default React.memo(CommentTab);

